var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 1.6H9.456C9.12 0.672 8.24 0 7.2 0C6.16 0 5.28 0.672 4.944 1.6H1.6C0.72 1.6 0 2.32 0 3.2V14.4C0 15.28 0.72 16 1.6 16H12.8C13.68 16 14.4 15.28 14.4 14.4V3.2C14.4 2.32 13.68 1.6 12.8 1.6ZM7.2 1.6C7.64 1.6 8 1.96 8 2.4C8 2.84 7.64 3.2 7.2 3.2C6.76 3.2 6.4 2.84 6.4 2.4C6.4 1.96 6.76 1.6 7.2 1.6ZM8 12.8H4C3.56 12.8 3.2 12.44 3.2 12C3.2 11.56 3.56 11.2 4 11.2H8C8.44 11.2 8.8 11.56 8.8 12C8.8 12.44 8.44 12.8 8 12.8ZM10.4 9.6H4C3.56 9.6 3.2 9.24 3.2 8.8C3.2 8.36 3.56 8 4 8H10.4C10.84 8 11.2 8.36 11.2 8.8C11.2 9.24 10.84 9.6 10.4 9.6ZM10.4 6.4H4C3.56 6.4 3.2 6.04 3.2 5.6C3.2 5.16 3.56 4.8 4 4.8H10.4C10.84 4.8 11.2 5.16 11.2 5.6C11.2 6.04 10.84 6.4 10.4 6.4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/reportIcon.12accbb4.svg";
export { ForwardRef as ReactComponent };